import React, { Component, Fragment } from 'react';
import './PerfilMobiliarioMtoProg.css'; 
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { DataGrid } from '@mui/x-data-grid';

import { esES } from '@mui/x-data-grid';
import { 
  getprogmtosactivo,
  clearErrors,
  deleteProgMtoActivo,
  postMtoActivoV2
} from '../../../redux/actions/mobiliarioactions';
import { getUsuariosAsistenciales } from '../../../redux/actions/useractions';

import { 
  Dialog, DialogActions, DialogContent, DialogTitle,
  FormControl, MenuItem, FormHelperText, Select, InputLabel,
  TextField, CircularProgress, Accordion, AccordionSummary, AccordionDetails, Button, Typography, 
  Grid,
  Stack,
  Box,Tooltip,IconButton,Card,
  CardMedia,
  CardActions
} from '@mui/material';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { FaArrowLeft, FaCheck, FaCheckCircle, FaPlus, FaTrash } from "react-icons/fa";
import MyButton from '../../../utils/MyButton';

import { useDropzone } from 'react-dropzone';

const FileDropzone = ({ onFileDrop }) => {
  const { getRootProps, getInputProps, acceptedFiles, fileRejections } = useDropzone({
    accept: {
      'application/pdf': ['.pdf'],
      'application/msword': ['.doc'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx']
    },
    maxFiles: 1,
    onDrop: onFileDrop
  });

  return (
    <div className="dropzone-container mt-4">
      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        <p className="dropzone-text">Arrastra y suelta el archivo aquí, o haz clic para seleccionarlo</p>
        <em className="dropzone-info">(Solo se permite subir un archivo PDF, DOC o DOCX)</em>
      </div>

      <aside className="dropzone-preview">
        {fileRejections.length > 0 && (
          <div className="file-error">
            <h4>Solo se puede cargar un archivo</h4>
          </div>
        )}

        {acceptedFiles.length > 0 && (
          <div className="file-accepted-dropzone">
            <h4 className='text-file-dropzone'>Archivo a cargar:</h4>
            <ul className="file-list-dropzone">
              {acceptedFiles.map(file => (
                <li key={file.path} className="file-item-dropzone">
                  {file.path} - {file.size} bytes
                </li>
              ))}
            </ul>
          </div>
        )}
      </aside>
    </div>
  );
};

class PerfilMobiliarioMtoProg extends Component {
  constructor() {
    super();
    this.state = {
      chasis: false,
      vaccesorios: false,
      vcontroles: false,
      vgeneral: false,
      limpieza: false,
      lelectronica: false,
      pcuantitativa: false,
      selectrica: false,
      lchasis: false,
      lubricacion: false,
      aptouso: true,
      repuestosreq: false,
      reqmtocorr: false,
      bajaequipo: false,
      pruebas: [{
        instrumento: '',
        prueba: '',
        valor: '',
        valormed: ''
      }],
      repuestos: [''],
      actividadesprog: '',
      actividadesreal: '',
      observaciones: '',
      horainicio: '',
      horafinal: '',
      firmarecibe: '',
      cargorecibe: '',
      fecha: '',
      fechafinal: '',
      metodoRecepcion: 'manual',
      firmaDigital: null,
      firmaGuardada: false,
      uploadingImage: false,
      nombreFirmante: '',
      cargoFirmante: '',
      usuarioRecibe: '',
      imagenFirma: null,
      nombreFirmaImagen: '',
      cargoFirmaImagen: '',
      errors: {},
      aprobado: {},
      open: false,
      opendelete: false,
      progid: '',
      clienteid: '',
      usuariosAsistenciales: [],
      imagenesAdjuntas: [],
      archivoPDF: null,
    };
    this.canvasRef = React.createRef();
  }

  componentDidMount() {
    this.props.getprogmtosactivo(this.props.mobiliarioId);
    window.addEventListener('resize', this.resizeCanvas);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.metodoRecepcion !== this.state.metodoRecepcion) {
      if (this.state.metodoRecepcion === "firma" && this.canvasRef.current) {
        this.initCanvas();
      } else if (this.state.metodoRecepcion === "usuario") {
        this.props.getUsuariosAsistenciales(this.props.clienteId);
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCanvas);
  }


// Initialize the canvas for signature
initCanvas = () => {
    if (!this.canvasRef.current) return;
    
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    // Set up canvas
    this.resizeCanvas();
    
    // Clear the canvas
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    
    // Set up drawing state
    this.isDrawing = false;
    this.lastX = 0;
    this.lastY = 0;
    
    // Set up event listeners for drawing
    canvas.addEventListener('mousedown', this.startDrawing);
    canvas.addEventListener('mousemove', this.draw);
    canvas.addEventListener('mouseup', this.stopDrawing);
    canvas.addEventListener('mouseout', this.stopDrawing);
    
    // Touch events
    canvas.addEventListener('touchstart', this.startDrawingTouch);
    canvas.addEventListener('touchmove', this.drawTouch);
    canvas.addEventListener('touchend', this.stopDrawing);
}

// Resize canvas to fit container
resizeCanvas = () => {
    if (!this.canvasRef.current) return;
    
    const canvas = this.canvasRef.current;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    const container = canvas.parentElement;
    
    canvas.width = container.clientWidth * ratio;
    canvas.height = 200 * ratio;
    canvas.style.width = `${container.clientWidth}px`;
    canvas.style.height = "200px";
    
    const ctx = canvas.getContext("2d");
    ctx.scale(ratio, ratio);
    
    // Set drawing styles
    ctx.lineJoin = 'round';
    ctx.lineCap = 'round';
    ctx.lineWidth = 2;
    ctx.strokeStyle = 'black';
    
    // Fill with white background
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
}

// Start drawing
startDrawing = (e) => {
    const canvas = this.canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    this.isDrawing = true;
    this.lastX = e.clientX - rect.left;
    this.lastY = e.clientY - rect.top;
}

// Handle touch start
startDrawingTouch = (e) => {
    e.preventDefault();
    if (e.touches.length !== 1) return;
    
    const touch = e.touches[0];
    const canvas = this.canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    
    this.isDrawing = true;
    this.lastX = touch.clientX - rect.left;
    this.lastY = touch.clientY - rect.top;
}

// Draw on the canvas
draw = (e) => {
    if (!this.isDrawing) return;
    
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext('2d');
    const rect = canvas.getBoundingClientRect();
    
    const currentX = e.clientX - rect.left;
    const currentY = e.clientY - rect.top;
    
    ctx.beginPath();
    ctx.moveTo(this.lastX, this.lastY);
    ctx.lineTo(currentX, currentY);
    ctx.stroke();
    
    this.lastX = currentX;
    this.lastY = currentY;
}

// Handle touch move
drawTouch = (e) => {
    e.preventDefault();
    if (!this.isDrawing || e.touches.length !== 1) return;
    
    const touch = e.touches[0];
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext('2d');
    const rect = canvas.getBoundingClientRect();
    
    const currentX = touch.clientX - rect.left;
    const currentY = touch.clientY - rect.top;
    
    ctx.beginPath();
    ctx.moveTo(this.lastX, this.lastY);
    ctx.lineTo(currentX, currentY);
    ctx.stroke();
    
    this.lastX = currentX;
    this.lastY = currentY;
}

// Stop drawing
stopDrawing = () => {
    this.isDrawing = false;
}

// Clear digital signature
clearSignature = () => {
    if (!this.canvasRef.current) return;
    
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    // Clear canvas
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    
    this.setState({ firmaDigital: null });
}

// Check if canvas is empty
isCanvasEmpty = () => {
    if (!this.canvasRef.current) return true;
    
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    const pixelData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    
    // Check if all pixel data is white (255, 255, 255, 255)
    for (let i = 0; i < pixelData.length; i += 4) {
        // Check RGB values (skip alpha)
        if (pixelData[i] !== 255 || pixelData[i + 1] !== 255 || pixelData[i + 2] !== 255) {
            return false; // Found a non-white pixel
        }
    }
    
    return true; // Canvas is empty (all white)
}

// Save digital signature
saveSignature = () => {
  if (!this.canvasRef.current) return;
  
  if (!this.isCanvasEmpty()) {
    const signatureData = this.canvasRef.current.toDataURL('image/png');
    
    // Guardar la firma y establecer firmaGuardada a true
    this.setState({ 
      firmaDigital: signatureData,
      firmaGuardada: true, // Indicador visual de que se guardó la firma
      errors: {
        ...this.state.errors,
        firmaDigital: null
      }
    });
    
    // Mostrar un mensaje de confirmación que desaparece después de unos segundos
    setTimeout(() => {
      this.setState({ firmaGuardada: false });
    }, 3000);
  } else {
    // Mostrar error - firma vacía
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        firmaDigital: "Es necesario firmar antes de guardar"
      }
    }));
  }
}

// Handle image upload
handleImageUpload = (event) => {
  const file = event.target.files[0];
  if (file) {
    // Indicar que estamos cargando la imagen
    this.setState({ uploadingImage: true });
    
    const reader = new FileReader();
    
    reader.onload = (e) => {
      this.setState({ 
        imagenFirma: e.target.result,
        uploadingImage: false, // Ya no estamos cargando
        errors: {
          ...this.state.errors,
          imagenFirma: null
        }
      });
    };
    
    reader.onerror = () => {
      this.setState({ 
        uploadingImage: false,
        errors: {
          ...this.state.errors,
          imagenFirma: "Error al cargar la imagen"
        }
      });
    };
    
    reader.readAsDataURL(file);
  }
}

handleImageButtonClick = () => {
  // Crear un input file temporal en lugar de usar una referencia persistente
  const fileInput = document.createElement('input');
  fileInput.type = 'file';
  fileInput.accept = 'image/*';
  
  // Configurar el manejador de eventos antes de activar el input
  fileInput.addEventListener('change', (event) => {
    const file = event.target.files[0];
    if (file) {
      this.setState({ uploadingImage: true });
      
      const reader = new FileReader();
      
      reader.onload = (e) => {
        this.setState({ 
          imagenFirma: e.target.result,
          uploadingImage: false,
          errors: {
            ...this.state.errors,
            imagenFirma: null
          }
        });
      };
      
      reader.onerror = () => {
        this.setState({ 
          uploadingImage: false,
          errors: {
            ...this.state.errors,
            imagenFirma: "Error al cargar la imagen"
          }
        });
      };
      
      reader.readAsDataURL(file);
    }
  });
  
  // Simular clic en el input
  fileInput.click();
}
// Get user info by ID from props
getUserInfo = (userId, field) => {
  const { usuariosAsistenciales } = this.props.user;
  
  if (!usuariosAsistenciales) return '';
  
  const user = usuariosAsistenciales.find(u => u.idUsuario === userId);
  
  // Si el campo es 'cargo' pero no existe, proporcionar un valor por defecto
  if (field === 'cargo' && (!user || !user[field])) {
    return 'Asistencial';
  }
  
  return user ? user[field] : '';
}

// Modified handlePostMto to include the new reception methods
handlePostMto = () => {
  const { credentials } = this.props.user;
    const pruebasProcesadas = this.state.pruebas.map((p, index) => ({
    [`instrumento${index + 1}`]: p.instrumento,
    [`prueba${index + 1}`]: p.prueba,
    [`valor${index + 1}`]: p.valor,
    [`valormed${index + 1}`]: p.valormed,
  }));
  // Determine which reception method to use and prepare the data accordingly
  let receptorInfo = {};
  
  switch(this.state.metodoRecepcion) {
    case 'manual':
      receptorInfo = {
        firmarecibe: this.state.firmarecibe,
        cargorecibe: this.state.cargorecibe,
        metodoRecepcion: 'manual'
      };
      break;
        
    case 'firma':
      // Get the signature data from the canvas
      if (this.canvasRef.current && !this.isCanvasEmpty()) {
        const signatureData = this.canvasRef.current.toDataURL('image/png');
          
        receptorInfo = {
          nombreFirmante: this.state.nombreFirmante,
          cargoFirmante: this.state.cargoFirmante,
          firmaDigital: signatureData,
          metodoRecepcion: 'firma'
        };
      } else {
        // Show error if no signature
        this.setState(prevState => ({
          errors: {
            ...prevState.errors,
            firmaDigital: "Es necesario firmar antes de guardar"
          }
        }));
        return; // Exit without submitting
      }
      break;
        
    case 'usuario':
      if (this.state.usuarioRecibe) {
        receptorInfo = {
          usuarioRecibe: this.state.usuarioRecibe,
          metodoRecepcion: 'usuario'
        };
      } else {
        // Show error if no user selected
        this.setState(prevState => ({
          errors: {
            ...prevState.errors,
            usuarioRecibe: "Debe seleccionar un usuario"
          }
        }));
        return; // Exit without submitting
      }
      break;
        
    case 'imagen':
      if (this.state.imagenFirma) {
        receptorInfo = {
          nombreFirmaImagen: this.state.nombreFirmaImagen,
          cargoFirmaImagen: this.state.cargoFirmaImagen,
          imagenFirma: this.state.imagenFirma,
          metodoRecepcion: 'imagen'
        };
      } else {
        // Show error if no image uploaded
        this.setState(prevState => ({
          errors: {
            ...prevState.errors,
            imagenFirma: "Se requiere una imagen de firma"
          }
        }));
        return; // Exit without submitting
      }
      break;
        
    default:
      receptorInfo = {
        firmarecibe: this.state.firmarecibe,
        cargorecibe: this.state.cargorecibe,
        metodoRecepcion: 'manual'
      };
  }
  
  // Prepare the complete maintenance data object
  const newMtoPreventivo = {
    chasis: this.state.chasis,
    vaccesorios: this.state.vaccesorios,
    vcontroles: this.state.vcontroles,
    vgeneral: this.state.vgeneral,
    limpieza: this.state.limpieza,
    lelectronica: this.state.lelectronica,
    pcuantitativa: this.state.pcuantitativa,
    selectrica: this.state.selectrica,
    lchasis: this.state.lchasis,
    lubricacion: this.state.lubricacion,
    actividadesprog: this.state.actividadesprog,
    actividadesreal: this.state.actividadesreal,
    observaciones: this.state.observaciones,
    horainicio: this.state.horainicio,
    horafinal: this.state.horafinal,
    fecha: this.state.fecha,
    fechafinal: this.state.fechafinal,
    ...this.state.repuestos.reduce((acc, valor, index) => {
        acc[`repuesto${index + 1}`] = valor;
        return acc;
      }, {}),
    aptouso: this.state.aptouso,
    repuestosreq: this.state.repuestosreq,
    reqmtocorr: this.state.reqmtocorr,
    bajaequipo: this.state.bajaequipo,
    imagenesAdjuntas: this.state.imagenesAdjuntas,
    archivoPDF: this.state.archivoPDF,
    ...Object.assign({}, ...pruebasProcesadas),
    ...receptorInfo
  };

  console.log(newMtoPreventivo);
  console.log(this.state.progid);

  // Determine which user handle to use based on user type
  const userHandle = credentials.tipouser === "Tecnico" 
    ? credentials.handleuser 
    : credentials.handle;
  
  // Use the new V2 function for submission
  this.props.postMtoActivoV2(
    newMtoPreventivo, 
    this.props.mobiliarioId, 
    this.props.clienteId, 
    this.state.progid, 
    userHandle
  ); 
}

handleAddPrueba = () => {
  if (this.state.pruebas.length < 6) {
    this.setState(prevState => ({
      pruebas: [...prevState.pruebas, { instrumento: '', prueba: '', valor: '', valormed: '' }]
    }));
  }
};

handlePruebaChange = (index, field, value) => {
  const nuevasPruebas = [...this.state.pruebas];
  nuevasPruebas[index][field] = value;
  this.setState({ pruebas: nuevasPruebas });
};

handleRemovePrueba = (index) => {
  const nuevasPruebas = [...this.state.pruebas];
  nuevasPruebas.splice(index, 1);
  this.setState({ pruebas: nuevasPruebas });
};

handleArchivoDrop = (acceptedFiles) => {
  if (acceptedFiles && acceptedFiles.length > 0) {
    this.setState({ archivoPDF: acceptedFiles[0] });
  }
};

handleImagenesSeleccionadas = (event) => {
  const archivos = Array.from(event.target.files);
  const nuevasImagenes = [...this.state.imagenesAdjuntas, ...archivos].slice(0, 3);
  this.setState({ imagenesAdjuntas: nuevasImagenes });
};

handleRemoveImagen = (index) => {
  const nuevas = [...this.state.imagenesAdjuntas];
  nuevas.splice(index, 1);
  this.setState({ imagenesAdjuntas: nuevas });
};

handleAddRepuesto = () => {
  if (this.state.repuestos.length < 6) {
    this.setState((prevState) => ({
      repuestos: [...prevState.repuestos, '']
    }));
  }
};

handleRemoveRepuesto = (index) => {
  const nuevos = [...this.state.repuestos];
  nuevos.splice(index, 1);
  this.setState({ repuestos: nuevos });
};

handleRepuestoChange = (index, value) => {
  const nuevos = [...this.state.repuestos];
  nuevos[index] = value;
  this.setState({ repuestos: nuevos });
};

      static getDerivedStateFromProps(props, state) {
        const newState = {};
    
        if (props.UI.errors) {
            newState.errors = props.UI.errors;
        }
    
        if (props.UI.aprobado) {
           newState.aprobado = props.UI.aprobado;
        }
    
        return Object.keys(newState).length > 0 ? newState : null;
    }
     
    

    handleOpen=(rawdataprogid,rawdatafecha,rawdatahora,rawdataactividadesprog)=>{
       

        this.setState({open:true,aprobado:{},progid:rawdataprogid,fecha:rawdatafecha,horainicio:rawdatahora,actividadesprog:rawdataactividadesprog});
    
        };

     handleClose=()=>{
           // this.props.clearErrors();
           if(this.state.aprobado.mensaje){
             this.props.getprogmtosactivo(this.props.mobiliarioId);
              this.setState({open:false,errors:{},aprobado:{}});
           }else{
            this.setState({open:false,errors:{},aprobado:{}});
           }
            
            };

    
     handleOpenDelete=(rawdataprogid,rawdataclienteid)=>{
    
                this.setState({opendelete:true,progid:rawdataprogid,clienteid:rawdataclienteid,errors:{},aprobado:{}});
               
                };
        
    handleCloseDelete=()=>{
                   // this.props.clearErrors();
                   if(this.state.aprobado.mensaje){
                    this.props.getprogmtosactivo(this.props.mobiliarioId);
                     this.setState({opendelete:false,errors:{},aprobado:{}});
                  }else{
                   this.setState({opendelete:false,errors:{},aprobado:{}});
                  }
                  
                    };
    handleDelete=()=>{
      const {credentials}=this.props.user;
      if(credentials.tipouser==="Tecnico"){
        console.log("Mantenimiento borrado desde:"+credentials.tipouser)
        console.log("Perfil de Ingenieria"+credentials.handleuser)
        //mandar el user de ingenieria
        this.props.deleteProgMtoActivo(this.state.clienteid,this.state.progid,this.props.mobiliarioId,credentials.handleuser);
        
       // this.handleEditProgMto(this.state.progid); 
            }else{
              //mandar el handle user normal 
              console.log("Mantenimiento enviado desde:"+credentials.tipouser)
              console.log("Perfil de Ingenieria"+credentials.handle)
              this.props.deleteProgMtoActivo(this.state.clienteid,this.state.progid,this.props.mobiliarioId,credentials.handle);
              //this.handleEditProgMto(this.state.progid); 
            }
     
     
    
  
    }

      handleChange=(event)=>{
                      this.setState({ [event.target.name]:event.target.value});
                      
                 };
    
  


    handleMethodChange = (event) => {
      const method = event.target.value;
      this.setState({ metodoRecepcion: method });
      
      // Si selecciona usuario, cargar la lista de usuarios asistenciales
      if (method === 'usuario') {
        this.props.getUsuariosAsistenciales(this.props.clienteId);
      }
    }
    
    render() {
        const handleRealizar = (row) => {
            // Abrir el diálogo de realizar mantenimiento
            this.handleOpen(row.progid, row.fecha, row.hora, row.actividades);
          };
          
          const handleBorrar = (row) => {
            // Abrir el diálogo de confirmación de borrar
            this.handleOpenDelete(row.progid, this.props.clienteId);
          };
        const {progmtosmobiliario,loadingmto}= this.props.dataMob; 
      
        const {errors}=this.state;
        const{aprobado}=this.state;
        const { UI:{loading}}=this.props; 
     
      
        
        const columns = [
            {
                field: 'acciones',
                headerName: 'Acciones',
                width: 120,
                sortable: false,
                filterable: false,
                disableColumnMenu: true,
                renderCell: (params) => (
                  <Stack direction="row" spacing={1}>
                    <Tooltip title="Realizar Mantenimiento">
                      <span>
                        <IconButton 
                          size="small"
                          color="primary"
                          onClick={() => handleRealizar(params.row)}
                          disabled={params.row.estado === 'Realizado'}
                        >
                          <FaPlus size={16} />
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip title="Borrar Programación">
                      <IconButton 
                        size="small"
                        color="#d7d7d7"
                        onClick={() => handleBorrar(params.row)}
                      >
                        <FaTrash size={16} />
                      </IconButton>
                    </Tooltip>
                  </Stack>
                ),
              },
            { field: 'fecha', headerName: 'Fecha', width: 120 },
            { field: 'mesnombre', headerName: 'Mes', width: 120 },
            { field: 'hora', headerName: 'Hora', width: 120 },
            { field: 'duracion', headerName: 'Duración', width: 120 },
            { field: 'estado', headerName: 'Estado', width: 140 },
            { field: 'actividades', headerName: 'Actividades', width: 200 },
           
          ];

        
     let mapeoprogmtos=!loadingmto?(
         <div>
    <Box sx={{ height: 600, width: '100%', mt: 2 }}>
    <DataGrid
  rows={progmtosmobiliario}
  columns={columns}
  getRowId={(row) => row.progid}
  autoHeight
  pageSize={5}
  rowsPerPageOptions={[5, 10, 20]}
  disableSelectionOnClick
  localeText={esES.components.MuiDataGrid.defaultProps.localeText} // 👈 Esto cambia TODO a Español
  sx={{
    borderRadius: 2,
    backgroundColor: '#fff',
    boxShadow: 3,
    '& .MuiDataGrid-cell': {
      fontSize: 14,
    },
    '& .MuiDataGrid-columnHeaders': {
      backgroundColor: '#0588FB',
      color: '#fff',
      fontWeight: 'bold',
      fontSize: 15,
    },
    '& .MuiDataGrid-row:hover': {
      backgroundColor: '#f5f5f5',
    },
  }}
/>
  </Box>

     
         </div>
           

        ):(  <div className="div_cargando">
            <CircularProgress size={50}color="primary" className="login-progress" />
            </div>);
            
       

        return (
           <div className="listamtoprog-container">
              
            <div className="listamtoprog-table">
            {mapeoprogmtos}
            </div>

            <Dialog
             open={this.state.open}
             onClose={this.handleClose}
             fullWidth
            maxWidth="sm"
            >
              {this.state.aprobado.mensaje ? (
              
              <div className='div-aprobado'>
                  <div className='div-icono-aprobado'>
                    <FaCheck color="#ffffff" className='icono-aprobado'/>
                  </div>
                  <h2 className='text-aprobado'>Reporte Cargado Exitosamente</h2>
              </div>
                
                ) : (<div>
                    <DialogTitle>
                    <Typography sx={{ 
                        fontSize: '20px', 
                        fontWeight: 600, 
                        color: '#0468BF', 
                        textAlign: 'center' 
                    }}>
                        Realizar Reporte de Mantenimiento Preventivo
                    </Typography>
                    </DialogTitle>
                  <DialogContent>
                    <form>

                    <Accordion>
  <AccordionSummary
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1a-content"
    id="panel1a-header"
  >
    <Typography sx={{
      color: '#0468BF',
      fontSize: '18px',
      fontWeight: 400,
      ml: 1,
    }}>
      Actividades Realizadas
    </Typography>
  </AccordionSummary>
  
  <AccordionDetails>
    <Grid container spacing={2}>
      {/* Primera fila */}
      <Grid item xs={12} md={6}>
        <FormControl fullWidth variant="outlined" size="small">
          <InputLabel>Inspección Chásis</InputLabel>
          <Select
            required
            name="chasis"
            value={this.state.chasis}
            onChange={this.handleChange}
            label="Inspección Chásis"
          >
            <MenuItem value=""><em>Seleccionar</em></MenuItem>
            <MenuItem value={true}>Sí</MenuItem>
            <MenuItem value={false}>No</MenuItem>
          </Select>
          <FormHelperText>{errors.chasis}</FormHelperText>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={6}>
        <FormControl fullWidth variant="outlined" size="small">
          <InputLabel>Verificar Accesorios</InputLabel>
          <Select
            required
            name="vaccesorios"
            value={this.state.vaccesorios}
            onChange={this.handleChange}
            label="Verificar Accesorios"
          >
            <MenuItem value=""><em>Seleccionar</em></MenuItem>
            <MenuItem value={true}>Sí</MenuItem>
            <MenuItem value={false}>No</MenuItem>
          </Select>
          <FormHelperText>{errors.vaccesorios}</FormHelperText>
        </FormControl>
      </Grid>

      {/* Segunda fila */}
      <Grid item xs={12} md={6}>
        <FormControl fullWidth variant="outlined" size="small">
          <InputLabel>Verificar Controles</InputLabel>
          <Select
            required
            name="vcontroles"
            value={this.state.vcontroles}
            onChange={this.handleChange}
            label="Verificar Controles"
          >
            <MenuItem value=""><em>Seleccionar</em></MenuItem>
            <MenuItem value={true}>Sí</MenuItem>
            <MenuItem value={false}>No</MenuItem>
          </Select>
          <FormHelperText>{errors.vcontroles}</FormHelperText>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={6}>
        <FormControl fullWidth variant="outlined" size="small">
          <InputLabel>Prueba Cuantitativa</InputLabel>
          <Select
            required
            name="pcuantitativa"
            value={this.state.pcuantitativa}
            onChange={this.handleChange}
            label="Prueba Cuantitativa"
          >
            <MenuItem value=""><em>Seleccionar</em></MenuItem>
            <MenuItem value={true}>Sí</MenuItem>
            <MenuItem value={false}>No</MenuItem>
          </Select>
          <FormHelperText>{errors.pcuantitativa}</FormHelperText>
        </FormControl>
      </Grid>

      {/* Tercera fila */}
      <Grid item xs={12} md={6}>
        <FormControl fullWidth variant="outlined" size="small">
          <InputLabel>Seguridad Eléctrica</InputLabel>
          <Select
            required
            name="selectrica"
            value={this.state.selectrica}
            onChange={this.handleChange}
            label="Seguridad Eléctrica"
          >
            <MenuItem value=""><em>Seleccionar</em></MenuItem>
            <MenuItem value={true}>Sí</MenuItem>
            <MenuItem value={false}>No</MenuItem>
          </Select>
          <FormHelperText>{errors.selectrica}</FormHelperText>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={6}>
        <FormControl fullWidth variant="outlined" size="small">
          <InputLabel>Limpieza</InputLabel>
          <Select
            required
            name="limpieza"
            value={this.state.limpieza}
            onChange={this.handleChange}
            label="Limpieza"
          >
            <MenuItem value=""><em>Seleccionar</em></MenuItem>
            <MenuItem value={true}>Sí</MenuItem>
            <MenuItem value={false}>No</MenuItem>
          </Select>
          <FormHelperText>{errors.limpieza}</FormHelperText>
        </FormControl>
      </Grid>

      {/* Cuarta fila */}
      <Grid item xs={12} md={6}>
        <FormControl fullWidth variant="outlined" size="small">
          <InputLabel>Lubricación de Partes</InputLabel>
          <Select
            required
            name="lubricacion"
            value={this.state.lubricacion}
            onChange={this.handleChange}
            label="Lubricación de Partes"
          >
            <MenuItem value=""><em>Seleccionar</em></MenuItem>
            <MenuItem value={true}>Sí</MenuItem>
            <MenuItem value={false}>No</MenuItem>
          </Select>
          <FormHelperText>{errors.lubricacion}</FormHelperText>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={6}>
        <FormControl fullWidth variant="outlined" size="small">
          <InputLabel>Limpieza Electrónica</InputLabel>
          <Select
            required
            name="lelectronica"
            value={this.state.lelectronica}
            onChange={this.handleChange}
            label="Limpieza Electrónica"
          >
            <MenuItem value=""><em>Seleccionar</em></MenuItem>
            <MenuItem value={true}>Sí</MenuItem>
            <MenuItem value={false}>No</MenuItem>
          </Select>
          <FormHelperText>{errors.lelectronica}</FormHelperText>
        </FormControl>
      </Grid>

      {/* Quinta fila */}
      <Grid item xs={12} md={6}>
        <FormControl fullWidth variant="outlined" size="small">
          <InputLabel>Limpieza de Chásis</InputLabel>
          <Select
            required
            name="lchasis"
            value={this.state.lchasis}
            onChange={this.handleChange}
            label="Limpieza de Chásis"
          >
            <MenuItem value=""><em>Seleccionar</em></MenuItem>
            <MenuItem value={true}>Sí</MenuItem>
            <MenuItem value={false}>No</MenuItem>
          </Select>
          <FormHelperText>{errors.lchasis}</FormHelperText>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={6}>
        <FormControl fullWidth variant="outlined" size="small">
          <InputLabel>Verificación General</InputLabel>
          <Select
            required
            name="vgeneral"
            value={this.state.vgeneral}
            onChange={this.handleChange}
            label="Verificación General"
          >
            <MenuItem value=""><em>Seleccionar</em></MenuItem>
            <MenuItem value={true}>Sí</MenuItem>
            <MenuItem value={false}>No</MenuItem>
          </Select>
          <FormHelperText>{errors.vgeneral}</FormHelperText>
        </FormControl>
      </Grid>
    </Grid>
  </AccordionDetails>
</Accordion>

<Accordion>
  <AccordionSummary
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel2a-content"
    id="panel2a-header"
  >
    <Typography sx={{
      color: '#0468BF',
      fontSize: '18px',
      fontWeight: 400,
      ml: 1,
    }}>
      Mediciones Realizadas
    </Typography>
  </AccordionSummary>

  <AccordionDetails>
    {this.state.pruebas.map((prueba, index) => (
      <Fragment key={index}>
        <Grid item xs={12} md={3} mt={1}>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            label={`Instrumento ${index + 1}`}
            value={prueba.instrumento}
            onChange={(e) => this.handlePruebaChange(index, 'instrumento', e.target.value)}
            error={Boolean(errors[`instrumento${index + 1}`])}
            helperText={errors[`instrumento${index + 1}`]}
          />
        </Grid>

        <Grid item xs={12} md={3} mt={1}>
          <FormControl fullWidth variant="outlined" size="small" error={Boolean(errors[`prueba${index + 1}`])}>
            <InputLabel>Variable</InputLabel>
            <Select
              value={prueba.prueba}
              onChange={(e) => this.handlePruebaChange(index, 'prueba', e.target.value)}
              label="Variable"
            >
              <MenuItem value=""><em>Seleccionar</em></MenuItem>
              <MenuItem value="velocidad">Velocidad</MenuItem>
               <MenuItem value="rpm">RPM</MenuItem>
              <MenuItem value="energia">Energía</MenuItem>
              <MenuItem value="flujo">Flujo</MenuItem>
              <MenuItem value="nibp">NIBP</MenuItem>
              <MenuItem value="peep">PEEP</MenuItem>
              <MenuItem value="presion">Presión</MenuItem>
              <MenuItem value="relacionie">Relación I:E</MenuItem>
              <MenuItem value="ecg">ECG</MenuItem>
              <MenuItem value="temperatura">Temperatura</MenuItem>
              <MenuItem value="peso">Peso</MenuItem>
              <MenuItem value="fio2">FIO2</MenuItem>
              <MenuItem value="volumen">Volumen</MenuItem>
              <MenuItem value="spo2">Spo2</MenuItem>
              <MenuItem value="frecuencia">Frecuencia</MenuItem>
              <MenuItem value="dB">dB</MenuItem>
              <MenuItem value="etco2">EtCO2</MenuItem> 
              <MenuItem value="co2inspirado">CO2 Inspirado</MenuItem>
              <MenuItem value="frecuenciarespiratoria">Frecuencia Respiratoria</MenuItem>
              <MenuItem value="frecuenciacardiaca">Frecuencia Cardíaca</MenuItem>
              <MenuItem value="IBP">Presión Invasiva</MenuItem>
              <MenuItem value="presionpico">Presión Pico</MenuItem>
              <MenuItem value="corriente">Corriente (A)</MenuItem>
              <MenuItem value="voltaje">Voltaje (V)</MenuItem>
              <MenuItem value="potencia">Potencia (W)</MenuItem>
              <MenuItem value="resistencia">Resistencia (Ohm)</MenuItem>
              <MenuItem value="frecuenciaelectrica">Frecuencia Eléctrica (Hz)</MenuItem>
              <MenuItem value="ph">pH</MenuItem>
              <MenuItem value="pco2">PCO2</MenuItem>
              <MenuItem value="po2">PO2</MenuItem>
              <MenuItem value="concentraciongas">Concentración de Gas</MenuItem>
              <MenuItem value="tiemporespuesta">Tiempo de Respuesta</MenuItem>
              <MenuItem value="linealidad">Linealidad</MenuItem>
              <MenuItem value="exactitud">Exactitud</MenuItem>
              <MenuItem value="precision">Precisión</MenuItem>
            </Select>
             <FormHelperText>{errors[`prueba${index + 1}`]}</FormHelperText>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={2} mt={1}>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            label="Valor Referencia"
            value={prueba.valor}
            onChange={(e) => this.handlePruebaChange(index, 'valor', e.target.value)}
            error={Boolean(errors[`valor${index + 1}`])}
            helperText={errors[`valor${index + 1}`]}
          />
        </Grid>

        <Grid item xs={12} md={2} mt={1}>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            label="Valor Medido"
            value={prueba.valormed}
            onChange={(e) => this.handlePruebaChange(index, 'valormed', e.target.value)}
            error={Boolean(errors[`valormed${index + 1}`])}
            helperText={errors[`valormed${index + 1}`]}
          />
        </Grid>

        <Grid item xs={12} md={2} display="flex" alignItems="center" justifyContent="center">
          <Tooltip title="Eliminar prueba">
            <IconButton color="error" onClick={() => this.handleRemovePrueba(index)}>
              <FaTrash />
            </IconButton>
          </Tooltip>
        </Grid>
      </Fragment>
    ))}

    {this.state.pruebas.length < 6 && (
        <Grid item xs={12}>
          <Button
            variant="outlined"
            startIcon={<FaPlus />}
            onClick={this.handleAddPrueba}
          >
            Agregar Prueba
          </Button>
        </Grid>
      )}
  </AccordionDetails>
</Accordion>

<Accordion>
  <AccordionSummary
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel3a-content"
    id="panel3a-header"
  >
    <Typography sx={{
      color: '#0468BF',
      fontSize: '18px',
      fontWeight: 400,
      ml: 1,
    }}>
      Descripcion de Actividades
    </Typography>
  </AccordionSummary>
  <AccordionDetails>
    <Grid container spacing={2}>
      <Grid item xs={12} mt={1}>
        <TextField
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          size="small"
          label="Actividades Programadas"
          name="actividadesprog"
          value={this.state.actividadesprog}
          onChange={this.handleChange}
          error={Boolean(errors.actividadesprog)}
          helperText={errors.actividadesprog}
        />
      </Grid>
    </Grid>

    <Grid container spacing={2}>
      <Grid item xs={12} mt={1}>
        <TextField
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          size="small"
          label="Actividades Realizadas"
          name="actividadesreal"
          value={this.state.actividadesreal}
          onChange={this.handleChange}
          error={Boolean(errors.actividadesreal)}
          helperText={errors.actividadesreal}
        />
      </Grid>
    </Grid>
    <Grid container spacing={2}>
      <Grid item xs={12} mt={1}>
        <TextField
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          size="small"
          label="Observaciones"
          name="observaciones"
          value={this.state.observaciones}
          onChange={this.handleChange}
          error={Boolean(errors.observaciones)}
          helperText={errors.observaciones}
        />
      </Grid>
    </Grid>
  </AccordionDetails>
</Accordion>

<Accordion>
  <AccordionSummary
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel3a-content"
    id="panel3a-header"
  >
    <Typography sx={{
      color: '#0468BF',
      fontSize: '18px',
      fontWeight: 400,
      ml: 1,
    }}>
      Archivos Adjuntos
    </Typography>
  </AccordionSummary>
  <AccordionDetails>
    {
      //Dropzone para cargar archivos debe incluir el nombre del archivo que se quiere subir
    }
      <Grid container spacing={2}>

          {/* Archivo PDF/DOC/DOCX */}
          <Grid item xs={12}>
            <Typography variant="subtitle2" sx={{
          color: '#0468BF',
          fontSize: '16px',
          fontWeight: 400,
          ml: 1,
        }}>Adjuntar archivo PDF, DOC o DOCX</Typography>
            <FileDropzone onFileDrop={this.handleArchivoDrop} />
          </Grid>
          </Grid>

             {
              //Visualización previa de imagenes
            }

            <Grid item xs={12}>
            <Typography variant="subtitle2" sx={{
          color: '#0468BF',
          fontSize: '16px',
          fontWeight: 400,
          ml: 1,
          mt:2
        }}>Adjuntar imágenes (JPG, PNG)</Typography>

            <Button
              variant="contained"
              component="label"
              disabled={this.state.imagenesAdjuntas.length >= 3}
            >
              Seleccionar imágenes
              <input
                type="file"
                accept="image/*"
                multiple
                hidden
                onChange={this.handleImagenesSeleccionadas}
              />
            </Button>
          </Grid>

         <Grid item xs={12}>
          <Typography variant="subtitle2" sx={{
          color: '#0468BF',
          fontSize: '16px',
          fontWeight: 400,
          ml: 1,
          mt:2
        }} gutterBottom>Imágenes seleccionadas</Typography>
          <Grid container spacing={2}>
            {this.state.imagenesAdjuntas.map((img, idx) => (
              <Grid item xs={12} sm={4} md={4} key={idx}>
                <Card sx={{ width: '100%', aspectRatio: '1 / 1', position: 'relative' }}>
                  <CardMedia
                    component="img"
                    image={URL.createObjectURL(img)}
                    alt={`Imagen ${idx + 1}`}
                    sx={{
                      objectFit: 'cover',
                      width: '100%',
                      height: '100%',
                      aspectRatio: '1 / 1'
                    }}
                  />
                  <CardActions sx={{ position: 'absolute', top: 0, right: 0 }}>
                    <Tooltip title="Eliminar imagen">
                      <IconButton color="error" onClick={() => this.handleRemoveImagen(idx)}>
                        <FaTrash />
                      </IconButton>
                    </Tooltip>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>

  </AccordionDetails>
</Accordion>

<Accordion>
  <AccordionSummary
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel3a-content"
    id="panel3a-header"
  >
    <Typography sx={{
      color: '#0468BF',
      fontSize: '18px',
      fontWeight: 400,
      ml: 1,
    }}>
      Repuestos Recomendados 
    </Typography>
  </AccordionSummary>
  <AccordionDetails>
    <Grid container spacing={2}>
      {this.state.repuestos.map((repuesto, index) => (
        <Grid item xs={12} sm={6} key={index}>
          <TextField
            fullWidth
            label={`Repuesto ${index + 1}`}
            value={repuesto}
            onChange={(e) => this.handleRepuestoChange(index, e.target.value)}
            variant="outlined"
            size="small"
            InputProps={{
              endAdornment: this.state.repuestos.length > 1 && (
                <Tooltip title="Eliminar">
                  <IconButton onClick={() => this.handleRemoveRepuesto(index)} edge="end" size="small" color="error">
                    <FaTrash />
                  </IconButton>
                </Tooltip>
              )
            }}
          />
        </Grid>
      ))}
  
      {this.state.repuestos.length < 6 && (
        <Grid item xs={12}>
          <Button
            variant="outlined"
            startIcon={<FaPlus />}
            onClick={this.handleAddRepuesto}
          >
            Agregar Repuesto
          </Button>
        </Grid>
      )}
    </Grid>
  </AccordionDetails>
</Accordion>

<Accordion>
  <AccordionSummary
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel3a-content"
    id="panel3a-header"
  >
    <Typography sx={{
      color: '#0468BF',
      fontSize: '18px',
      fontWeight: 400,
      ml: 1,
    }}>
      Estado del Equipo
    </Typography>
  </AccordionSummary>

  <AccordionDetails>
    <Grid item xs={12} md={6} mt={2}>
      <FormControl fullWidth variant="outlined" size="small">
        <InputLabel>¿Equipo Apto para su Uso?</InputLabel>
        <Select
          required
          name="aptouso"
          value={this.state.aptouso}
          onChange={this.handleChange}
          label="¿Equipo Apto para su Uso?"
        >
          <MenuItem value=""><em>Seleccionar</em></MenuItem>
          <MenuItem value={true}>Sí</MenuItem>
          <MenuItem value={false}>N/A</MenuItem>
        </Select>
        <FormHelperText>{errors.aptouso}</FormHelperText>
      </FormControl>
    </Grid>
    <Grid item xs={12} md={6} mt={2}>
      <FormControl fullWidth variant="outlined" size="small">
        <InputLabel>¿Requiere repuestos adicionales?</InputLabel>
        <Select
          required
          name="repuestosreq"
          value={this.state.repuestosreq}
          onChange={this.handleChange}
          label="¿Requiere repuestos adicionales?"
        >
          <MenuItem value=""><em>Seleccionar</em></MenuItem>
          <MenuItem value={true}>Sí</MenuItem>
          <MenuItem value={false}>N/A</MenuItem>
        </Select>
        <FormHelperText>{errors.repuestosreq}</FormHelperText>
      </FormControl>
    </Grid>
    <Grid item xs={12} md={6} mt={2}>
      <FormControl fullWidth variant="outlined" size="small">
        <InputLabel>¿Requiere mantenimiento correctivo?</InputLabel>
        <Select
          required
          name="reqmtocorr"
          value={this.state.reqmtocorr}
          onChange={this.handleChange}
          label="¿Requiere mantenimiento correctivo?"
        >
          <MenuItem value=""><em>Seleccionar</em></MenuItem>
          <MenuItem value={true}>Sí</MenuItem>
          <MenuItem value={false}>N/A</MenuItem>
        </Select>
        <FormHelperText>{errors.reqmtocorr}</FormHelperText>
      </FormControl>
    </Grid>
    <Grid item xs={12} md={6} mt={2}>
      <FormControl fullWidth variant="outlined" size="small">
        <InputLabel>¿Requiere dar de baja el Equipo?</InputLabel>
        <Select
          required
          name="bajaequipo"
          value={this.state.bajaequipo}
          onChange={this.handleChange}
          label="¿Requiere dar de baja el Equipo?"
        >
          <MenuItem value=""><em>Seleccionar</em></MenuItem>
          <MenuItem value={true}>Sí</MenuItem>
          <MenuItem value={false}>N/A</MenuItem>
        </Select>
        <FormHelperText>{errors.bajaequipo}</FormHelperText>
      </FormControl>
    </Grid>
  </AccordionDetails>
</Accordion>

<Accordion>
  <AccordionSummary
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel4a-content"
    id="panel4a-header"
  >
    <Typography sx={{
      color: '#0468BF',
      fontSize: '18px',
      fontWeight: 400,
      ml: 1,
    }}>
      Fecha y Hora
    </Typography>
  </AccordionSummary>

  <AccordionDetails>
    <Grid container spacing={2}>
      {/* Fila: Fechas */}
      <Grid item xs={12} sm={6}>
        <TextField
          required
          fullWidth
          type="date"
          name="fecha"
          id="fecha"
          label="Fecha de Realización"
          value={this.state.fecha}
          onChange={this.handleChange}
          helperText={errors.fecha}
          error={Boolean(errors.fecha)}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          required
          fullWidth
          type="date"
          name="fechafinal"
          id="fechafinal"
          label="Fecha Final"
          value={this.state.fechafinal}
          onChange={this.handleChange}
          helperText={errors.fechafinal}
          error={Boolean(errors.fechafinal)}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      {/* Fila: Horas */}
      <Grid item xs={12} sm={6}>
        <TextField
          required
          fullWidth
          type="time"
          name="horainicio"
          id="horainicio"
          label="Hora de Inicio"
          value={this.state.horainicio}
          onChange={this.handleChange}
          helperText={errors.horainicio}
          error={Boolean(errors.horainicio)}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          required
          fullWidth
          type="time"
          name="horafinal"
          id="horafinal"
          label="Hora Final"
          value={this.state.horafinal}
          onChange={this.handleChange}
          helperText={errors.horafinal}
          error={Boolean(errors.horafinal)}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
    </Grid>
  </AccordionDetails>
</Accordion>

<Accordion>
  <AccordionSummary
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel5a-content"
    id="panel5a-header"
  >
    <Typography sx={{
      color: '#0468BF',
      fontSize: '18px',
      fontWeight: 400,
      ml: 1,
    }}>
      Personal que recibe la actividad
    </Typography>
  </AccordionSummary>

  <AccordionDetails>
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormControl fullWidth size="small">
          <InputLabel>Método de recepción</InputLabel>
          <Select
            name="metodoRecepcion"
            value={this.state.metodoRecepcion || 'manual'}
            label="Método de recepción"
            onChange={(e) => {
              this.handleChange(e);
              this.handleMethodChange(e);
            }}
            error={Boolean(errors.metodoRecepcion)}
          >
            <MenuItem value="manual">Ingreso manual</MenuItem>
            <MenuItem value="firma">Firma digital</MenuItem>
            <MenuItem value="usuario">Seleccionar usuario</MenuItem>
            <MenuItem value="imagen">Cargar imagen</MenuItem>
          </Select>
          <FormHelperText>{errors.metodoRecepcion}</FormHelperText>
        </FormControl>
      </Grid>

      {/* ==== Personaliza según el método seleccionado ==== */}
      {this.state.metodoRecepcion === "manual" && (
        <>
          <Grid item xs={12}>
            <TextField
              fullWidth
              required
              variant="outlined"
              size="small"
              label="Nombre de quien recibe la actividad"
              name="firmarecibe"
              value={this.state.firmarecibe}
              onChange={this.handleChange}
              error={Boolean(errors.firmarecibe)}
              helperText={errors.firmarecibe}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              required
              variant="outlined"
              size="small"
              label="Cargo de quien recibe la actividad"
              name="cargorecibe"
              value={this.state.cargorecibe}
              onChange={this.handleChange}
              error={Boolean(errors.cargorecibe)}
              helperText={errors.cargorecibe}
            />
          </Grid>
        </>
      )}

      {this.state.metodoRecepcion === "firma" && (
        <>
          <Grid item xs={12}>
            <div className="firma-canvas-container">
              <canvas
                ref={this.canvasRef}
                id="firma-digital-canvas"
                className="firma-canvas"
                width="500"
                height="200"
              />
            </div>
            <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
              <Button variant="outlined" onClick={this.clearSignature}>
                Limpiar firma
              </Button>
              <Button variant="contained" onClick={this.saveSignature}>
                Guardar firma
              </Button>
            </Stack>
          </Grid>

          {this.state.firmaGuardada && (
            <Grid item xs={12}>
              <Typography color="success.main" align="center">
                Firma guardada correctamente
              </Typography>
            </Grid>
          )}

          <Grid item xs={12}>
            <TextField
              fullWidth
              required
              variant="outlined"
              size="small"
              label="Nombre del firmante"
              name="nombreFirmante"
              value={this.state.nombreFirmante}
              onChange={this.handleChange}
              error={Boolean(errors.nombreFirmante)}
              helperText={errors.nombreFirmante}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              required
              variant="outlined"
              size="small"
              label="Cargo del firmante"
              name="cargoFirmante"
              value={this.state.cargoFirmante}
              onChange={this.handleChange}
              error={Boolean(errors.cargoFirmante)}
              helperText={errors.cargoFirmante}
            />
          </Grid>
        </>
      )}

      {this.state.metodoRecepcion === "usuario" && (
        <>
          <Grid item xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel>Usuario que recibe</InputLabel>
              <Select
                name="usuarioRecibe"
                value={this.state.usuarioRecibe || ''}
                onChange={this.handleChange}
                label="Usuario que recibe"
                error={Boolean(errors.usuarioRecibe)}
              >
                <MenuItem value=""><em>Seleccione un usuario</em></MenuItem>
                {this.props.user.usuariosAsistenciales?.map(user => (
                  <MenuItem key={user.idUsuario} value={user.idUsuario}>
                    {user.nombre} {user.cargo ? `- ${user.cargo}` : ''}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{errors.usuarioRecibe}</FormHelperText>
            </FormControl>
          </Grid>

          {this.state.usuarioRecibe && (
            <Grid item xs={12}>
              <Typography variant="body2" sx={{ mt: 2 }}>
                <strong>Nombre:</strong> {this.getUserInfo(this.state.usuarioRecibe, 'nombre')}
              </Typography>
              <Typography variant="body2">
                <strong>Cargo:</strong> {this.getUserInfo(this.state.usuarioRecibe, 'cargo')}
              </Typography>
            </Grid>
          )}
        </>
      )}

      {this.state.metodoRecepcion === "imagen" && (
        <>
          <Grid item xs={12}>
            <Button
              fullWidth
              variant="contained"
              onClick={this.handleImageButtonClick}
              disabled={this.state.uploadingImage}
            >
              {this.state.uploadingImage ? 'Procesando...' : 'Cargar imagen de firma'}
            </Button>
          </Grid>

          {this.state.imagenFirma && (
            <Grid item xs={12}>
              <Box
                component="img"
                src={this.state.imagenFirma}
                alt="Vista previa de firma"
                sx={{ maxWidth: '100%', maxHeight: 200, mt: 2 }}
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <TextField
              fullWidth
              required
              variant="outlined"
              size="small"
              label="Nombre del firmante"
              name="nombreFirmaImagen"
              value={this.state.nombreFirmaImagen}
              onChange={this.handleChange}
              error={Boolean(errors.nombreFirmaImagen)}
              helperText={errors.nombreFirmaImagen}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              required
              variant="outlined"
              size="small"
              label="Cargo del firmante"
              name="cargoFirmaImagen"
              value={this.state.cargoFirmaImagen}
              onChange={this.handleChange}
              error={Boolean(errors.cargoFirmaImagen)}
              helperText={errors.cargoFirmaImagen}
            />
          </Grid>
        </>
      )}
    </Grid>
  </AccordionDetails>
</Accordion>
                
                    </form>  
                  </DialogContent>
                </div>
               
                )}
            
            

            <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleClose}>
            <FaArrowLeft color="#D3D7DC" className="icon-formulario"/>
             </MyButton>
             {loading ? (
                <CircularProgress size={30} color="primary" className="login-progress" />
              ) : (
                this.state.aprobado.mensaje ? (
                  <MyButton tip="Continuar" onClick={this.handleClose}>
                    <FaCheckCircle color="#20B90C" className="icon-formulario" />
                  </MyButton>
                ) : (
                  <MyButton tip="Realizar Mantenimiento" onClick={this.handlePostMto}>
                    <FaPlus color="#03178C" className="icon-formulario" />
                  </MyButton>
                )
              )}
           </DialogActions>

            </Dialog>
          
           
           
            <Dialog
             open={this.state.opendelete}
             onClose={this.handleCloseDelete}
             fullWidth
            maxWidth="sm"
            >

            {this.state.aprobado.mensaje ? (
              
              <div className='div-aprobado'>
                  <div className='div-icono-delete'>
                    <FaTrash color="#ffffff" className='icono-aprobado'/>
                  </div>
                  <h2 className='text-aprobado'>Reporte Borrado Exitosamente</h2>
              </div>
                
                ):(<div>
                <DialogTitle>¿Estás seguro de borrar programación de Mto? También se borrará el mantenimiento asociado</DialogTitle>
                </div>)}
            

            <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleCloseDelete}>
            <FaArrowLeft color="#D3D7DC" className="icon-formulario"/>
             </MyButton>
             {loading ? (
                <CircularProgress size={30} color="primary" className="login-progress" />
              ) : (
                this.state.aprobado.mensaje ? (
                  <MyButton tip="Continuar" onClick={this.handleCloseDelete}>
                    <FaCheckCircle color="#f9044e" className="icon-formulario" />
                  </MyButton>
                ) : (
                  <MyButton tip="Borrar Programación" onClick={this.handleDelete}>
                    <FaTrash color="#03178C" className="icon-formulario" />
                  </MyButton>
                )
              )}
            
           </DialogActions>
            </Dialog>
        
           </div>

         
        )
    }
}

PerfilMobiliarioMtoProg.propTypes = {
  
    postMtoActivoV2:PropTypes.func.isRequired,
  getUsuariosAsistenciales:PropTypes.func.isRequired,
  getprogmtosactivo: PropTypes.func.isRequired,
 
    user:PropTypes.object.isRequired,    
    data:PropTypes.object.isRequired,
    clearErrors:PropTypes.func.isRequired,
    UI:PropTypes.object.isRequired,
    deleteProgMtoActivo:PropTypes.func.isRequired,
   
  };

const mapActionsToProps={getprogmtosactivo,clearErrors,deleteProgMtoActivo,postMtoActivoV2, getUsuariosAsistenciales};

const mapStateToProps = (state)=>({
    dataMob:state.dataMob,
    data:state.data,
    user:state.user,
    UI:state.UI
})



export default connect(mapStateToProps,mapActionsToProps)(PerfilMobiliarioMtoProg);



